var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.69025 1.02866L11.1328 3.86713L14.3711 4.32413C15.8881 4.53815 16.5816 6.41022 15.4121 7.5165L13.0861 9.71492L13.6335 12.8127C13.9139 14.3995 12.2296 15.4653 10.9033 14.7895L7.99985 13.3085L5.09726 14.7891C3.76902 15.467 2.08615 14.3977 2.36617 12.8127L2.91361 9.71492L0.587917 7.51681C-0.582388 6.40972 0.11351 4.53806 1.62847 4.32416L4.86707 3.86711L6.31028 1.02866C7.00731 -0.342828 8.99333 -0.342947 9.69025 1.02866Z",
    fill: "#FFA500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRate);
export default __webpack_public_path__ + "static/media/rate.23c88a747d4e4108f331022076c10c3a.svg";
export { ForwardRef as ReactComponent };